import React, { useState, useEffect, useContext, useRef } from 'react'
import success from '../assets/success.png'
import sports from '../assets/sports.png'
import story from '../assets/story.png'
import app from '../assets/app.png'
import health from '../assets/health.png'
import RCPodcast from '../assets/RCPodcast.png'
import RCPodcast2 from '../assets/RCPodcast2.png'
import RCPodcast3 from '../assets/RCPodcast3.png'
import trending1 from '../assets/Trending1.png'
import trending2 from '../assets/Trending2.png'
import { NavbarContext } from '../context/NavbarContext'
import { useNavigate } from 'react-router-dom'
import { PodcastAllOptionsContext } from '../context/PodcastAllOptionsContext'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BiLeftArrowCircle } from "react-icons/bi";
import { BiRightArrowCircle } from "react-icons/bi";
import { ApiContext } from '../context/ApiContext'
import { getAppData } from '../apiService'
import { ShimmerCircularImage, ShimmerThumbnail } from 'react-shimmer-effects'
import { useTranslation } from 'react-i18next'

function Podcast() {
    const {t} = useTranslation();
    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        rows: 1,
        arrows: false,
    };
    const { Categories, Categories2, Categories3, rss, setRss, setImage, Categories3_id, setCategories3_id } = useContext(ApiContext);
    const { navHeading, setNavHeading } = useContext(NavbarContext)
    const { podcastId, setPodcastId } = useContext(PodcastAllOptionsContext)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    const navigate = useNavigate();
    const slidersRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // useEffect(()=>{
    // console.log("rss is ",rss,"Categories3_id",Categories3_id);

    // },[rss,Categories3_id])
    // useEffect(()=>{
    //   if(!Categories&&Categories2&&Categories3){
    // setLoading(true)
    //   }
    // },[Categories,Categories2,Categories3])
    useEffect(() => {
        if (Categories.length == 0 && Categories2.length == 0) {
            setLoading(true)
        } else if (Categories.length > 0 && Categories2.length > 0) {
            // console.log(Categories2);
            
            setLoading(false)
        }
    }, [Categories, Categories2])

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 600);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);




    const handlePodcastValue = (name, id) => {
        function capitalizeFirstLetter(str) {
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }

        const url = capitalizeFirstLetter(name);
        setPodcastId(id);
        setNavHeading(url);
        navigate(`/podcast/${url}`);
    };
    const handleRecentPodcast = (rss, imgs) => {
        setRss(rss);
        setImage(imgs)
        navigate(`/player`)
    }
    if (error) {
        return (
            <>
                <div className="blur-background"></div>
                <div className="error-container">
                    <p>{error}</p>
                </div>
            </>
        )
    }

    if (loading) {
        return (
            <div className="layout1-div">
                <div className="podcast-main">
                    <div className='podcast-main-inner-div1'>
                        <p className='podcast-heading1'>{t("Podcast.Categories")}</p>
                        <div className='slider-container1'>
                            <div className='slider-arrow1 left1'><ShimmerCircularImage size={35} /></div>

                            {isMobile ? <div className='slider-wrapper1234567890'><ShimmerThumbnail width={172} /> <ShimmerThumbnail width={172} /> <ShimmerThumbnail width={172} /> <ShimmerThumbnail width={172} /> <ShimmerThumbnail width={172} /></div> : <div className='slider-wrapper1234567890'><ShimmerThumbnail width={200} /> <ShimmerThumbnail width={200} /> <ShimmerThumbnail width={200} /> <ShimmerThumbnail width={200} /> <ShimmerThumbnail width={200} /></div>}

                            <div className='slider-arrow1 right1'><ShimmerCircularImage size={35} /></div>
                        </div>
                        <div className='all-recent-podcast-div1'>
                            <div className='slider-wrapper1234567890'><ShimmerThumbnail width={200} /> <ShimmerThumbnail width={200} /> <ShimmerThumbnail width={200} /> <ShimmerThumbnail width={200} /> <ShimmerThumbnail width={200} /></div>
                        </div>
                    </div>
                    <div className='podcast-main-inner-div2'>
                        <div className='podcast-second-recent-pd'>
                            <p className='podcast-heading2'>{t("Podcast.Recent")}</p>

                            {isMobile ? <div className='all-recent-podcast-div2345678901'><ShimmerThumbnail width={172} /> <ShimmerThumbnail width={172} /> <ShimmerThumbnail width={172} /> <ShimmerThumbnail width={172} /><ShimmerThumbnail width={172} /><ShimmerThumbnail width={172} /></div> : <div className='all-recent-podcast-div2345678901'><ShimmerThumbnail width={200} /> <ShimmerThumbnail width={200} /> <ShimmerThumbnail width={200} /> <ShimmerThumbnail width={200} /><ShimmerThumbnail width={200} /><ShimmerThumbnail width={200} /></div>}

                        </div>
                    </div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        );
    }


    return (
        <>
            {isMobile ? (<>{Categories ? <div className='layout1-div'>
                <div className='podcast-main'>
                    <div className='podcast-main-inner-div12'>
                        <p className='podcast-heading1'>{t("Podcast.Categories")}</p>
                        <div className='all-recent-podcast-div12'>
                            {/* {slicedResent.map((item)=>( */}
                            {Categories.map((item) => (
                                <div className='single-recent-podcast12' key={item.id} onClick={() => handlePodcastValue(item.name, item.id)}>
                                    <p className='single-recent-podcast-heading'>{item.name}</p>
                                    <div className='single-recent-podcast-image12'>
                                        <img src={item.image} alt={item.name} style={{ width: "100%", height: "100%" }} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='podcast-main-inner-div212'>
                        <div className='podcast-second-recent-pd12'>
                            <p className='podcast-heading2' style={{ paddingLeft: "5px" }}>{t("Podcast.Recent")}</p>
                            <div className='all-recent-podcast-div212'>
                                {Categories2.map((item) => (
                                    <div className='single-recent-podcast-div2-image12' key={item.id} onClick={() => handleRecentPodcast(item.rss_feed, item.image)}>
                                        <img src={item.image} alt={item.title} style={{ width: "100%", height: "100%" }} />
                                    </div>
                                ))}
                            </div>
                        </div>
                        {/* <div className='podcast-trending-main12'>
                <p className='podcast-heading3' style={{paddingLeft:"5px"}}>Trending podcasts</p>
                <div className='all-trending-podcast-div212'>
                    <div className='single-trending-podcast-div212'>
                    <div className='single-trending-podcast-div2-image12'>
                    <img src={trending1} alt="success" style={{width:"100%",height:"100%"}}/>
                    </div>
                    <div className='single-recent-podcast-div2-content'>
                        <p className='podcast-single-trending-heading'>Premium story</p>
                        <p className='podcast-created-by'>James Hoyce</p>
                    </div>
                    </div>
                    
                    <div className='single-trending-podcast-div212'>
                    <div className='single-trending-podcast-div2-image12'>
                    <img src={trending1} alt="success" style={{width:"100%",height:"100%"}}/>
                    </div>
                    <div className='single-recent-podcast-div2-content'>
                        <p className='podcast-single-trending-heading'>Premium story</p>
                        <p className='podcast-created-by'>James Hoyce</p>
                    </div>
                    </div>

                    <div className='single-trending-podcast-div212'>
                    <div className='single-trending-podcast-div2-image12'>
                    <img src={trending1} alt="success" style={{width:"100%",height:"100%"}}/>
                    </div>
                    <div className='single-recent-podcast-div2-content'>
                        <p className='podcast-single-trending-heading'>Premium story</p>
                        <p className='podcast-created-by'>James Hoyce</p>
                    </div>
                    </div>

                    <div className='single-trending-podcast-div212'>
                    <div className='single-trending-podcast-div2-image12'>
                    <img src={trending1} alt="success" style={{width:"100%",height:"100%"}}/>
                    </div>
                    <div className='single-recent-podcast-div2-content'>
                        <p className='podcast-single-trending-heading'>Premium story</p>
                        <p className='podcast-created-by'>James Hoyce</p>
                    </div>
                    </div>

                    <div className='single-trending-podcast-div212'>
                    <div className='single-trending-podcast-div2-image12'>
                    <img src={trending1} alt="success" style={{width:"100%",height:"100%"}}/>
                    </div>
                    <div className='single-recent-podcast-div2-content'>
                        <p className='podcast-single-trending-heading'>Premium story</p>
                        <p className='podcast-created-by'>James Hoyce</p>
                    </div>
                    </div>

                    <div className='single-trending-podcast-div212'>
                    <div className='single-trending-podcast-div2-image12'>
                    <img src={trending1} alt="success" style={{width:"100%",height:"100%"}}/>
                    </div>
                    <div className='single-recent-podcast-div2-content'>
                        <p className='podcast-single-trending-heading'>Premium story</p>
                        <p className='podcast-created-by'>James Hoyce</p>
                    </div>
                    </div>
                </div>

                </div> */}

                        {/* <div className='podcast-second-recent-pd1'>
                <p className='podcast-heading21'>single Podcasts</p>
                <div className='all-recent-podcast-div21'>
                    {Categories3.map((item)=>(
                        <div className='single-recent-podcast-div21-image' key={item.id} onClick={()=>handleRecentPodcast22(item.id)}>
                        <img src={item.image} alt={item.title} style={{width:"100%",height:"100%"}}/>
                        </div>
                    ))}
                </div>
                </div> */}

                    </div>
                </div>
            </div> : <div>No data available</div>}</>) : (
                <>

                    {Categories ? <div className='layout1-div'>
                        <div className='podcast-main'>
                            <div className='podcast-main-inner-div1'>
                                <p className='podcast-heading1'>{t("Podcast.Categories")}</p>
                                <div className="slider-container1">
                                    <button className="slider-arrow1 left1" onClick={() => slidersRef.current.slickPrev()}>
                                        <BiLeftArrowCircle />
                                    </button>

                                    <div className="slider-wrapper1">
                                        <Slider ref={slidersRef} {...settings}>
                                            {Categories.map((item) => (
                                                <div key={item.id} className="slide-item" onClick={() => handlePodcastValue(item.name, item.id)}>
                                                    <div className="slider-d-jhu1" style={{ cursor: "pointer" }}>
                                                        <p className='podcast-para-ytr'>{item.name}</p>
                                                        <div className='podcast-hjgwqjht8'><img className='css-nadvt4' src={item.image} alt={`Slide ${item.image}`} /></div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>

                                    <button className="slider-arrow1 right1" onClick={() => slidersRef.current.slickNext()}>
                                        <BiRightArrowCircle />
                                    </button>
                                </div>
                                <div className='all-recent-podcast-div1'>
                                    {Categories.map((item) => (
                                        <div className='single-recent-podcast' key={item.id} onClick={() => handlePodcastValue(item.name, item.id)}>
                                            <p className='single-recent-podcast-heading'>{item.name}</p>
                                            <div className='single-recent-podcast-image'>
                                                <img src={item.image} alt={item.name} style={{ width: "100%", height: "100%" }} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className='podcast-main-inner-div2'>
                                <div className='podcast-second-recent-pd'>
                                    <p className='podcast-heading2'>{t("Podcast.Recent")}</p>
                                    <div className='all-recent-podcast-div2'>
                                        {Categories2.map((item) => (
                                            <div className='single-recent-podcast-div2-image' key={item.id} onClick={() => handleRecentPodcast(item.rss_feed, item.image)} >
                                                <img src={item.image} alt={item.title} style={{ width: "100%", height: "100%" }} />
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/*                 
                <div className='podcast-trending-main'>
                <p className='podcast-heading3'>Trending podcasts</p>
                <div className='all-trending-podcast-div2'>
                    <div className='single-trending-podcast-div2'>
                    <div className='single-trending-podcast-div2-image'>
                    <img src={trending1} alt="success" style={{width:"100%",height:"100%"}}/>
                    </div>
                    <div className='single-recent-podcast-div2-content'>
                        <p className='podcast-single-trending-heading'>Premium story</p>
                        <p className='podcast-created-by'>James Hoyce</p>
                    </div>
                    </div>
                    
                    <div className='single-trending-podcast-div2'>
                    <div className='single-trending-podcast-div2-image'>
                    <img src={trending1} alt="success" style={{width:"100%",height:"100%"}}/>
                    </div>
                    <div className='single-recent-podcast-div2-content'>
                        <p className='podcast-single-trending-heading'>Premium story</p>
                        <p className='podcast-created-by'>James Hoyce</p>
                    </div>
                    </div>

                    <div className='single-trending-podcast-div2'>
                    <div className='single-trending-podcast-div2-image'>
                    <img src={trending1} alt="success" style={{width:"100%",height:"100%"}}/>
                    </div>
                    <div className='single-recent-podcast-div2-content'>
                        <p className='podcast-single-trending-heading'>Premium story</p>
                        <p className='podcast-created-by'>James Hoyce</p>
                    </div>
                    </div>

                    <div className='single-trending-podcast-div2'>
                    <div className='single-trending-podcast-div2-image'>
                    <img src={trending1} alt="success" style={{width:"100%",height:"100%"}}/>
                    </div>
                    <div className='single-recent-podcast-div2-content'>
                        <p className='podcast-single-trending-heading'>Premium story</p>
                        <p className='podcast-created-by'>James Hoyce</p>
                    </div>
                    </div>

                    <div className='single-trending-podcast-div2'>
                    <div className='single-trending-podcast-div2-image'>
                    <img src={trending1} alt="success" style={{width:"100%",height:"100%"}}/>
                    </div>
                    <div className='single-recent-podcast-div2-content'>
                        <p className='podcast-single-trending-heading'>Premium story</p>
                        <p className='podcast-created-by'>James Hoyce</p>
                    </div>
                    </div>

                    <div className='single-trending-podcast-div2'>
                    <div className='single-trending-podcast-div2-image'>
                    <img src={trending1} alt="success" style={{width:"100%",height:"100%"}}/>
                    </div>
                    <div className='single-recent-podcast-div2-content'>
                        <p className='podcast-single-trending-heading'>Premium story</p>
                        <p className='podcast-created-by'>James Hoyce</p>
                    </div>
                    </div>
                </div>

                </div>
 */}

                                {/* <div className='podcast-trending-main1'></div>                        this is a sepration line */}

                                {/* 
                <div className='podcast-second-recent-pd1'>
                <p className='podcast-heading21'>single Podcasts</p>
                <div className='all-recent-podcast-div21'>
                    {Categories3.map((item)=>(
                        <div className='single-recent-podcast-div21-image' key={item.id} onClick={()=>handleRecentPodcast22(item.id,item)}>
                            //  {console.log(Categories,"Categoriessssssssssssssss")} 
                        <img src={item.image} alt={item.title} style={{width:"100%",height:"100%"}}/>
                        </div>
                    ))}
                </div>
                </div> 
                
                */}


                            </div>
                        </div>
                    </div> : <div>No data available</div>}
                </>
            )}
        </>
    )
}

export default Podcast